import React from "react";

// Decorative SVG stickers used throughout the site.
// All accept className for positioning.

export const ArrowSticker = ({ className = "", color = "#FF1493" }) => (
  <svg
    className={className}
    viewBox="0 0 120 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5 60 C 25 20, 60 10, 100 30"
      stroke={color}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M100 30 L 88 24 M100 30 L 96 42"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const CircleScribble = ({ className = "", color = "#FF1493" }) => (
  <svg
    className={className}
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M70 12 C 24 16, 14 60, 30 96 C 48 130, 110 132, 124 90 C 138 48, 110 14, 70 12 Z"
      stroke={color}
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
      strokeDasharray="4 6"
    />
  </svg>
);

export const Starburst = ({ className = "", color = "#FF1493" }) => (
  <svg
    className={className}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M50 5 L57 38 L92 32 L62 50 L92 68 L57 62 L50 95 L43 62 L8 68 L38 50 L8 32 L43 38 Z"
      fill={color}
    />
  </svg>
);

export const Underline = ({ className = "", color = "#FF1493" }) => (
  <svg
    className={className}
    viewBox="0 0 200 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <path
      d="M4 10 Q 50 2, 100 8 T 196 6"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export const TinyStar = ({ className = "", color = "#FF1493" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2 L14 10 L22 12 L14 14 L12 22 L10 14 L2 12 L10 10 Z"
      fill={color}
    />
  </svg>
);

export const Squiggle = ({ className = "", color = "#0F0F0F" }) => (
  <svg
    className={className}
    viewBox="0 0 200 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <path
      d="M0 10 Q 25 0, 50 10 T 100 10 T 150 10 T 200 10"
      stroke={color}
      strokeWidth="2.5"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Dot = ({ className = "", color = "#FF1493" }) => (
  <span
    className={className}
    style={{
      display: "inline-block",
      width: "0.6em",
      height: "0.6em",
      borderRadius: "999px",
      background: color,
      verticalAlign: "middle",
    }}
    aria-hidden="true"
  />
);
